/*
 * Copyright (c) 2021 Omnicell. All rights reserved.
 *
 * This program contains proprietary, trade secret information of
 * Omnicell. and may not be copied, reproduced or reverse engineered
 * in any way without the prior written permission of Omnicell.
 */

import React, { useContext, useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { defaultCarouselSettings } from '../../../constants/carouselSettings';
import { DataContext } from '../../../contexts/DataContext';
import LocationResultCard from './LocationResultCard';

const LocationResultCarousel = ({ locations, clinics, flowIdentifier, language }) => {
  const [canRender, setCanRender] = useState(true);
  const [carouselSettings, setCarouselSettings] = useState({ ...defaultCarouselSettings });

  const { currentFlowIdentifier, setSelectedLocationIndex } = useContext(DataContext);
  const carouselRef = useRef(null);
  let slider;

  useEffect(() => {
    if (flowIdentifier !== currentFlowIdentifier) {
      setCanRender(false);
      setSelectedLocationIndex(null);
    }
  }, [currentFlowIdentifier]);

  useEffect(() => {
    if (!locations) {
      return;
    }

    if (locations.length < 3) {
      setCarouselSettings({
        ...carouselSettings,
        centerMode: false,
        variableWidth: locations.length === 1 ? false : true
      });
    }
  }, [locations]);

  // Focus first Select Location button after carousel renders
  useEffect(() => {
    if (locations && locations.length > 0 && carouselRef.current) {
      setTimeout(() => {
        const firstLocationButton = carouselRef.current.querySelector('.submission-button');
        if (firstLocationButton) {
          firstLocationButton.focus();
        }
      }, 300);
    }
  }, [locations]);

  const goToLocation = selectedIndex => {
    if (slider) {
      slider.slickGoTo(selectedIndex);
    }
  };

  const renderLocations = () =>
    locations?.map((l, i) => (
      <LocationResultCard
        key={i}
        clinics={clinics}
        locationIndex={i}
        location={l}
        withMargin={!!locations && locations.length > 1}
        goToLocation={goToLocation}
        language={language}
      />
    ));

  return canRender ? (
    <div ref={carouselRef}>
      <Slider {...carouselSettings} ref={s => (slider = s)}>
        {renderLocations()}
      </Slider>
    </div>
  ) : null;
};

export default React.memo(LocationResultCarousel);
